//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import $ from "jquery";

(function() {
    // Service to provide support for managing the save state of an object
  angular.module('curalate').service('UnsavedChangesService', [
    '$log',
    '$window',
    'ErrorNotificationService',
    function(
            $log,
            $window,
            ErrorNotificationService,
        ) {
      const SAVE_STATE = {
        CLEAN: 'CLEAN',
        DIRTY: 'DIRTY',
        FAILED: 'FAILED',
        NOT_LOADED: 'NOT_LOADED',
      };

      const cleanState = {
                // original object, reference to actual object
        changingObject: null,
                // deep clone of object
        staticObject: null,
                // keeps track if there was an error thrown to not spam the user with error dialogs
        hasThrownError: false,
                // initial parent object save state
        saveState: SAVE_STATE.NOT_LOADED,
      };

      const self = this;

      let currentState = angular.copy(cleanState);

            // Attaching and detaching watching objects
      self.attachObject = function(object) {
        currentState.staticObject = angular.copy(object);
        currentState.changingObject = object;
      };

      self.hasAttachedObject = function() {
        return currentState.changingObject !== null;
      };

      self.detachObject = function() {
        currentState = angular.copy(cleanState);
      };

      self.onObjectChange = function() {
        if (angular.equals(currentState.changingObject, currentState.staticObject)) {
          currentState.saveState = SAVE_STATE.CLEAN;
          self.removeUnsavedPrompt();
        } else {
          currentState.saveState = SAVE_STATE.DIRTY;
          self.attachUnsavedPrompt();
        }
      };

      self.hasUnsavedChanges = function() {
        if (currentState.saveState === SAVE_STATE.NOT_LOADED) {
          return false;
        }
        let hasUnsavedChanges;
        switch (currentState.saveState) {
          case SAVE_STATE.DIRTY:
            hasUnsavedChanges = true;
            break;
          case SAVE_STATE.FAILED:
            if (!currentState.hasThrownError) {
              hasUnsavedChanges = true;
              const error = 'Objects changes have not been saved properly.';
              $log.error(error);
              ErrorNotificationService.showDefaultErrorDialog(error);
              currentState.hasThrownError = true;
            }
            break;
          default:
            hasUnsavedChanges = false;
            break;
        }
        return hasUnsavedChanges;
      };

      self.attachUnsavedPrompt = function() {
                // FYI: This opens up a prompt to alert users they're leaving the page with unsaved changes
        $($window).on('beforeunload', () => true);
      };

      self.removeUnsavedPrompt = function() {
        $($window).off('beforeunload');
      };

      self.updateChanges = function() {
        currentState.staticObject = angular.copy(currentState.changingObject);
        self.onObjectChange();
      };

      self.saveFailed = function() {
        currentState.saveState = SAVE_STATE.FAILED;
      };

      return self;
    },
  ]);
})();
